import { createBrowserHistory, History } from 'history';

const historyTemp: History | null = null;

// create history if it is missing
const history: History =
  historyTemp === null ? createBrowserHistory() : historyTemp;

export { history };
